import React, { useState } from "react";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import { FaEdit, FaPlus } from "react-icons/fa";
import RouteModal from "../../../Component/BasicComponents/Modal/RouteModal";
import CountryMasterModalContent from "../ModalContent/CountryMasterModalContent";
import {
  useAddCountry,
  useGetCountryList,
  useUpdateCountry,
} from "./hook/useSuperSetting";
// import { useGetCurrency } from "./hook/useCompony";

const CountryMasterDataColumns = (handleEdit: (row: any) => void) => [
  {
    name: "Country",
    selector: (row: { Scountry: string }) => row.Scountry,
    sortable: true,
    wrap: true,
  },
  {
    name: "Currency",
    selector: (row: any) =>
      `${row.Currencies.Name}  ( ${row.Currencies.Shortcode} )`,
    sortable: true,
    wrap: true,
  },
  {
    name: "Action",
    cell: (row: any) => (
      <button
        onClick={() => handleEdit(row)}
        className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
        style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
      >
        <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
      </button>
    ),
  },
];

const CountryMasterTable = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filtersState, setFiltersState] = useState<any>({
    page: 1,
    limit: 10,
    search: null,
  });
  const [selectedRow, setSelectedRow] = useState(null);
  const [modalStatus, setModalStatus] = useState("");
  const [name, setName] = useState<string | any>("");
  const [selectedCurrency, setSelectedCurrency] = useState<any>(null);

  //===================Country Table List==========================

  const { data: allCountriesData } = useGetCountryList({
    enable: true,
    params: {
      search: filtersState?.search,
      page: filtersState?.page,
      limit: filtersState?.limit,
    },
  });

  const { mutate: addCountry } = useAddCountry();
  const { mutate: updateCountry } = useUpdateCountry();

  const handleClose = () => {
    setIsModalOpen(false);
    setModalStatus("");
    setSelectedRow(null);
    setName("");
    setSelectedCurrency(null);
  };

  const handleSubmit = (formData: { name: string; currency: any }) => {
    // e.preventDefault();
    console.log("HandleSubmit :::::::::::::;", formData);

    if (selectedRow && modalStatus === "Edit") {
      const addCountryBody = {
        Scountry: formData?.name,
        Scurrency: formData?.currency,
      };
      updateCountry(addCountryBody, {
        onSuccess: () => {
          handleClose();
        },
      });
    } else {
      const addCountryBody = {
        Scountry: formData?.name,
        Scurrency: formData?.currency,
      };
      addCountry(addCountryBody, {
        onSuccess: () => {
          handleClose();
        },
      });
    }
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleEdit = (row: any) => {
    console.log("row::::::::::::::::::::", row);
    setIsModalOpen(!isModalOpen);
    setSelectedRow(row);
    setModalStatus("Edit");
  };

  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };

  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  return (
    <div className="container mt-3">
      <BasicDataTable
        minHeightOfTable={370}
        Title="Country Master"
        data={allCountriesData?.data?.data}
        columns={CountryMasterDataColumns(handleEdit)}
        search={false}
        headerContent={
          <button
            onClick={() => toggleModal()}
            className="btn btn-info"
            style={{
              borderRadius: "20px",
              padding: "6px 12px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <FaPlus /> <span>Add Country</span>
          </button>
        }
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        paginationTotalRows={
          allCountriesData?.data?.pagination?.total_records || 0
        }
      />
      <RouteModal
        isOpen={isModalOpen}
        title={modalStatus === "Edit" ? "Edit Country" : "Add Country"}
        size="md"
        content={
          <CountryMasterModalContent
            handleSubmit={handleSubmit}
            handleClose={handleClose}
            selectedRow={selectedRow}
            modalStatus={modalStatus}
            name={name}
            setName={setName}
            selectedCurrency={selectedCurrency}
            setSelectedCurrency={setSelectedCurrency}
          />
        }
      />
    </div>
  );
};

export default CountryMasterTable;
